import type { FAQItem } from "@/services/dto";

export interface OutputTranslation {
    locale: string;
    answers: string[];
    questions: string[];
}

export interface OutputItem {
    id: string;
    isActive: boolean;
    order: number;
    title: string;
    key: string;
    translations: OutputTranslation[];
}

export function groupTranslationsByKey(data: FAQItem[]): OutputItem[] {
    // Tạo một object tạm để nhóm dữ liệu theo key
    const grouped: { [key: string]: OutputItem } = {};

    // Lặp qua từng object trong mảng data
    data.forEach(item => {
        const { key, translations, ...rest } = item;

        // Nếu key chưa tồn tại trong grouped, khởi tạo nó
        if (!grouped[key]) {
            grouped[key] = {
                ...rest,
                key,
                translations: []
            };
        }

        // Thêm tất cả translations vào grouped[key].translations
        grouped[key].translations.push(
            ...translations.map(t => ({
                locale: t.locale,
                answers: [t.answer],
                questions: [t.question]
            }))
        );
    });

    // Chuyển object grouped thành mảng và gộp translations theo locale
    return Object.values(grouped).map(item => {
        // Tạo một object để lưu translations đã gộp theo locale
        const uniqueTranslations: { [locale: string]: OutputTranslation } = {};

        // Lặp qua translations để gộp answers và questions theo locale
        item.translations.forEach(translation => {
            const { locale, answers, questions } = translation;

            // Nếu locale chưa tồn tại, khởi tạo nó
            if (!uniqueTranslations[locale]) {
                uniqueTranslations[locale] = { locale, answers: [], questions: [] };
            }

            // Thêm answers và questions vào danh sách tương ứng
            uniqueTranslations[locale].answers.push(...answers);
            uniqueTranslations[locale].questions.push(...questions);
        });

        return {
            ...item,
            translations: Object.values(uniqueTranslations)
        };
    });
}

export function sortDataByKey(data: OutputItem[]): OutputItem[] {
    const keyOrder: string[] = [
        'BRAND',
        'F&B',
        'EVENT',
        'FACILITIES',
        'SERVICE',
        'WIFI',
        'TAX_REFUND',
        'PAYMENT_METHOD',
        'STORAGE_OF_GOODS',
        'LOST_AND_FOUND',
        'REPAIR_SHOP',
        'OTHERS',
        'WEBSITE_OR_APP'
    ];

    return [...data].sort((a, b) => {
        const indexA = keyOrder.indexOf(a.key);
        const indexB = keyOrder.indexOf(b.key);
        
        // Nếu key không tồn tại trong keyOrder, đẩy xuống cuối
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        
        return indexA - indexB;
    });
}